import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const phoneNumber = "919909610001";
  const message = encodeURIComponent("Hello! I'm interested in learning more about KF Prints products.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white rounded-full shadow-lg hover:shadow-xl group whatsapp-pulse"
      style={{ padding: '12px 20px' }}
    >
      <MessageCircle size={22} className="fill-white" />
      <span className="text-sm font-sans font-medium hidden sm:inline">Chat with Us</span>
    </a>
  );
}
